import { TBoxPositionProps } from "./types";

export const getHorizontalMultiplier = ({ left, right }: TBoxPositionProps) =>
  left !== undefined ? 1 : right !== undefined ? -1 : 0;

export const getVerticalMultiplier = ({ top, bottom }: TBoxPositionProps) =>
  top !== undefined ? 1 : bottom !== undefined ? -1 : 0;
